import React, { useState, useEffect } from "react";
import Layout from "../../common/Layout";
import Tarif from "./Tarif";
import DatenFormular from "./DatenFormular";
import { useData } from "../../utils/dataProvider";
import "./style.scss";
import { useParams, useNavigate, redirect } from "react-router-dom";
import axios from "axios";
import { url } from "../../utils/config";
import { withFormik, Formik } from "formik";

const Formular = (props) => {
  const { page, setPage, setAuto } = useData();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { handleSubmit } = props;

  useEffect(() => {
    if (id) {
      axios.get(url + "/tarife/" + id).then((res) => {
        setData(res.data);
        setAuto(res.data[0].car.name);
      });
    }
  }, [id]);

  useEffect(() => {
    setPage(2);
  }, []);

  const tarifFormular = () => {
    switch (page) {
      case 2:
        return <Tarif data={data}></Tarif>;
      case 3:
        return <DatenFormular data={data} sub={handleSubmit}></DatenFormular>;
    }
  };

  if (data) {
    return <form onSubmit={handleSubmit}>{tarifFormular()}</form>;
  }
};

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Pflichtfeld";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Ungültig E-mail Address";
  }

  if (!values.prename) {
    errors.prename = "Pflichtfeld";
  }
  if (!values.name) {
    errors.name = "Pflichtfeld";
  }
  if (!values.phone) {
    errors.phone = "Pflichtfeld";
  }
  if (!values.street) {
    errors.street = "Pflichtfeld";
  }
  if (!values.city) {
    errors.city = "Pflichtfeld";
  }
  if (!values.birthday && values.legalProtection && values.privat) {
    errors.birthday = "Pflichtfeld";
  }
  if (!values.company && values.gewerbe) {
    errors.company = "Pflichtfeld";
  }
  if (!values.zip) {
    errors.zip = "Pflichtfeld";
  }
  if (!values.datenschutz) {
    errors.datenschutz = "Pflichtfeld";
  }
  if (values.vorversicherung || values.sfrContinue === "Ja") {
    if (!values.insurer) {
      errors.insurer = "Pflichtfeld";
    }
    if (!values.insuranceNumber) {
      errors.insuranceNumber = "Pflichtfeld";
    }
  }
  if (values.vorversicherung) {
    if (!values.changeDate) {
      errors.changeDate = "Pflichtfeld";
    }
  }
  console.log(errors);
  return errors;
};

const MyEnhancedForm = withFormik({
  mapPropsToValues: () => ({
    privat: true,
    vermietung: null,
    zahlungsweise: "lastschrift",
    tarif: null,
    gewerbe: null,
    vorversicherung: false,
    salutation: "Herr",
    street: null,
    prename: null,
    name: null,
    zip: null,
    company: null,
    city: null,
    email: null,
    phone: null,
    email: null,
    message: null,
    datenschutz: false,
    insurer: null,
    model: null,
    damageBefore: false,
    damageCount: null,
    damageAmount: null,
    insurerCancled: false,
    changeDate: null,
    birthday: null,
    insuranceNumber: null,
    legalProtection: null,
    vorsteuer: false,
    customerType: "Privatperson",
    sfrContinue: "Nein",
  }),

  validateOnChange: false,
  validate: (values) => validate(values),

  handleSubmit: (values, { props, setSubmitting }) => {
    axios
      .post(url + "/request", values)
      .then((res) => {
        setTimeout(() => {
          props.navigate("/finish/5");
          setSubmitting(false);
        }, 2000);
      })
      .catch((errors) => {
        setSubmitting(false);
        alert("Es gab eine Fehler bei Übermittlung.");
      });
  },
  displayName: "Formular",
})(Formular);

const FormikWrapper = () => {
  const navigate = useNavigate();
  return <MyEnhancedForm navigate={navigate} />;
};

export default FormikWrapper;
